import React from "react"

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { JobPosting } from "@/types/jobPosting"

import { JobPostingForm } from "./JobPostingForm"

interface JobPostingDialogProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  jobPosting?: JobPosting | null
  onClose: () => void
}

export const JobPostingDialog: React.FC<JobPostingDialogProps> = ({
  isOpen,
  setIsOpen,
  jobPosting,
  onClose,
}) => {
  const isEditing = !!jobPosting

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        setIsOpen(open)
        if (!open) {
          onClose()
        }
      }}
    >
      <DialogContent className="sm:max-w-[600px] max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{isEditing ? "Edit Job Posting" : "Create New Job Posting"}</DialogTitle>
          <DialogDescription>
            {isEditing
              ? "Edit the details of this job posting."
              : "Fill out the details below to create a new job posting that applicants can apply to."}
          </DialogDescription>
        </DialogHeader>
        <JobPostingForm
          key={jobPosting?.id || "new"}
          onClose={onClose}
          initialData={jobPosting || undefined}
        />
      </DialogContent>
    </Dialog>
  )
}
